import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Process from './components/Process';
import Technologies from './components/Technologies';
import Industries from './components/Industries';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './index.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Services />
      <Process />
      <Technologies />
      <Industries />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
